<template>
  <div
    class="room-schedule_container"
    :class="isSidebarOpened ? '' : `room-schedule_container--sidebar`"
  >
    <section v-show="isSidebarOpened" class="room-schedule_sidebar">
      <div class="fc-selected-rooms">
        <div
          v-for="selectedRoom in selectedRooms"
          :key="`selected-room-${selectedRoom.roomId}-${selectedRoom.startDate}`"
          style="margin-bottom: 12px"
        >
          <div style="margin-bottom: 6px; font-weight: 500">
            Phòng {{ selectedRoom.roomNum }}
          </div>
          <div
            v-for="(day, index) in selectedRoom.days"
            :key="`${day.start}-${day.end}`"
            style="margin-bottom: 4px"
          >
            <i
              class="el-icon-remove"
              style="cursor: pointer"
              @click="onRemoveSelectedRoom(selectedRoom, index)"
            ></i>
            {{ day.start.format('DD.MM') }} -
            {{ day.end.format('DD.MM') }}
          </div>
        </div>
        <div class="room-schedule_sidebar_buttons">
          <button
            type="button"
            class="btn primary small"
            :class="isDayGridEnabled ? 'outline' : ''"
            @click="onToggleDayGrid"
          >
            {{ isDayGridEnabled ? 'Hủy' : 'Chọn lịch' }}
          </button>
          <button
            :disabled="selectedRooms.length === 0"
            type="button"
            class="ml-10 btn primary small outline"
            @click="onConfirmRoomBooking"
          >
            Xác nhận
          </button>
        </div>
      </div>
      <hr />
      <div class="das-form-container das-form-group">
        <div class="das-form-row">
          <div class="das-form-col">
            <el-row :gutter="8">
              <el-col :span="24">
                <div class="das-form-input">
                  <div class="label">
                    {{ 'Từ ngày' }}
                  </div>
                  <CalendarSelect
                    v-model="queryParams.dateFrom"
                    mode="date"
                    @input="onChangeDateFrom"
                  />
                </div>
              </el-col>
              <el-col :span="24">
                <div class="das-form-input">
                  <div class="label">
                    {{ 'Đến ngày' }}
                  </div>
                  <CalendarSelect
                    v-model="queryParams.dateTo"
                    :min-max="{
                      min: new Date(queryParams.dateFrom),
                      max: $moment(queryParams.dateFrom)
                        .add('days', 31)
                        .format('YYYY-MM-DD')
                    }"
                    mode="date"
                  />
                </div>
              </el-col>
            </el-row>
            <div class="das-form-input">
              <div class="das-form-col">
                <label class="label">
                  {{ 'Khách sạn' }}
                </label>
                <el-select
                  v-model="queryParams.roomHotelId"
                  collapse-tags
                  filterable
                  clearable
                  placeholder="Select"
                  @change="onChangeHotel"
                >
                  <el-option
                    v-for="item in hotelOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
            <div class="das-form-input">
              <div class="label">
                {{ 'Hạng phòng' }}
              </div>
              <el-select
                v-model="queryParams.roomLevelId"
                collapse-tags
                filterable
                clearable
                placeholder="Select"
                @change="onChangeRoomLevel"
              >
                <el-option
                  v-for="item in filteredRoomLevelOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </div>
          </div>
        </div>
      </div>

      <div class="room-schedule_sidebar_buttons">
        <button class="btn primary small" @click="getRoomPlan">Tìm kiếm</button>
      </div>
      <hr />
      <div class="room-schedule_sidebar_calendar">
        <div class="das-form-input">
          <div>
            <div class="label">
              {{ 'Trạng thái phòng' }}
            </div>
            <div class="type-list">
              <div v-for="type in types" :key="type.value" class="type-item">
                <div
                  class="type-color"
                  :style="`background-color: rgb(${type.color});`"
                ></div>
                <span>{{ type.label }}</span>
              </div>
            </div>
          </div>
          <hr />

          <v-date-picker
            ref="calendar"
            v-model="displayDate"
            color="green"
            :min-date="currentQueryParams.dateFrom"
            :max-date="dateTo"
          ></v-date-picker>
          <hr />

          <div class="label flex align-center">
            {{ 'Ngày' }}
            <div class="flex align-center ml-10">
              <button
                class="mci-btn primary small rounded"
                :class="displayHour ? 'outline' : ''"
                @click="displayHour = false"
              >
                Theo ngày
              </button>
              <button
                class="mci-btn primary small rounded ml-10"
                :class="displayHour ? '' : 'outline'"
                @click="displayHour = true"
              >
                Theo giờ
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="room-schedule_calendar" style="position: relative">
      <span id="show-filter-button" class="" @click="onToggleSidebar">
        <i v-show="!isSidebarOpened" class="el-icon-caret-right"></i>
        <i v-show="isSidebarOpened" class="el-icon-caret-left"></i>
      </span>
      <FullCalendar
        ref="FullCalendar"
        :hide-bookable-cell="isDayGridEnabled"
        :is-day-grid-enabled="isDayGridEnabled"
        :display-date="displayDate"
        :display-hour="displayHour"
        :start-date="currentQueryParams.dateFrom"
        :total-days="totalDays"
        :schedule="roomSchedule"
        @refresh="getRoomPlan"
      ></FullCalendar>
      <!-- <FullCalendarDayBar></FullCalendarDayBar> -->
    </section>
  </div>
</template>
<script>
import { getHotelListApi } from '@/api/booking_service/bookingGroup'
import { getRoomLevel } from '@/api/reception/common'
import { getRoomPlan } from '@/api/report_service/report'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import FullCalendar from '@/components/FullCalendar/FullCalendar.vue'
export default {
  components: { CalendarSelect, FullCalendar },
  data() {
    return {
      types: [
        { color: '30, 132, 73', value: 1, label: 'Đã đặt phòng' },
        { color: '36, 113, 163', value: 2, label: 'Đang ở' },
        { color: '39, 55, 70 ', value: 3, label: 'Phòng không sử dụng' },
        { color: '125, 60, 152', value: 5, label: 'Đã trả phòng' },
        { color: '244, 208, 63 ', value: 6, label: 'Ở trong ngày' },
        { color: '146, 43, 33', value: 7, label: 'Đặt phòng tạm giữ' }
      ],
      displayDate: null,
      displayHour: false, // 0
      isSidebarOpened: true,
      queryParams: {
        dateFrom: this.$moment().subtract(1, 'd').format('YYYY-MM-DD'),
        dateTo: this.$moment().add(7, 'd').format('YYYY-MM-DD'),
        roomLevelId: null,
        roomHotelId: null
      },
      currentQueryParams: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        roomLevelId: null,
        roomHotelId: null
      },
      roomSchedule: [],
      roomLevelOptions: [],
      hotelOptions: [],
      selectedRooms: [],
      isDayGridEnabled: false
    }
  },
  computed: {
    totalDays() {
      return (
        this.$moment(this.currentQueryParams.dateTo).diff(
          this.$moment(this.currentQueryParams.dateFrom),
          'days'
        ) + 1
      )
    },
    dateTo() {
      return this.currentQueryParams.dateTo
    },
    filteredRoomLevelOptions() {
      if (
        this.queryParams.roomHotelId == null ||
        this.queryParams.roomHotelId === ''
      ) {
        return this.roomLevelOptions
      }
      return this.roomLevelOptions.filter(
        room => room.hotel_id === this.queryParams.roomHotelId
      )
    }
  },
  watch: {
    'selectedRooms.length': {
      handler() {
        this.selectedRooms = this.$refs.FullCalendar.selectedRooms
      }
    }
  },
  async beforeMount() {
    // await this.getRoomSchedule()
    await Promise.all([
      this.getRoomLevelOptions(),
      this.getHotelOptions(),
      this.getRoomPlan()
    ])
  },
  mounted() {
    this.selectedRooms = this.$refs.FullCalendar.selectedRooms
  },
  methods: {
    onChangeDateFrom() {
      this.queryParams.dateTo = this.$moment(this.queryParams.dateFrom)
        .add(7, 'days')
        .format('YYYY-MM-DD')
    },
    onRemoveSelectedRoom(room, index) {
      const cRoomIndex = this.selectedRooms.findIndex(
        e => e.room.room_id === room.room.room_id
      )
      this.selectedRooms[cRoomIndex].days.splice(index, 1)
      if (this.selectedRooms[cRoomIndex].days.length === 0) {
        this.selectedRooms.splice(cRoomIndex, 1)
      }
    },
    onConfirmRoomBooking() {
      sessionStorage.setItem(
        'defaultRooms',
        JSON.stringify(
          this.selectedRooms.map(room => {
            room.days.forEach(day => {
              day.start = day.start.format('YYYY-MM-DD')
              day.end = day.end.add(1, 'days').format('YYYY-MM-DD')
            })
            return room
          })
        )
      )
      this.$router.push({
        path: '/reservation/new_reservation'
      })
    },
    onToggleDayGrid() {
      this.isDayGridEnabled = !this.isDayGridEnabled
      if (!this.isDayGridEnabled) {
        this.selectedRooms.length = 0
      }
    },
    onToggleSidebar() {
      this.isSidebarOpened = !this.isSidebarOpened
      this.$nextTick(() => {
        this.$refs.FullCalendar.getMinDayCellWidth()
      })
    },
    onChangeHotel(value) {
      this.queryParams.roomLevelId = null
    },
    onChangeRoomLevel(value) {
      const selectedRoom = this.roomLevelOptions.find(
        level => level.id === value
      )

      this.queryParams.roomHotelId = selectedRoom.hotel_id
    },
    async getRoomLevelOptions() {
      await getRoomLevel().then(res => {
        this.roomLevelOptions = res.data
      })
    },
    async getHotelOptions() {
      await getHotelListApi().then(res => {
        this.hotelOptions = res.data
      })
    },
    async getRoomPlan() {
      await getRoomPlan(this.queryParams)
        .then(async response => {
          this.roomSchedule = response.data.map(group => {
            group.toggled = true
            return group
          })
          this.displayDate = this.queryParams.dateFrom
          Object.assign(this.currentQueryParams, this.queryParams)
          this.selectedRooms.length = 0
          this.isDayGridEnabled = false
        })
        .catch(err => {
          const message = err?.response?.data?.message
          this.$message({
            type: 'error',
            message: message ?? 'Đã có lỗi xảy ra'
          })
        })
    }
  }
}
</script>
<style scoped lang="scss">
#show-filter-button {
  user-select: none;
  position: absolute;
  top: 6px;
  left: 6px;
  background-color: white;
  border-radius: 4px;
  padding: 3px;
  cursor: pointer;
  color: rgb(var(--das-color-primary));
  display: grid;
  justify-items: center;
  align-items: center;
  &:hover {
    outline: white 1px solid;
    outline-offset: 2px;
  }
  i {
    display: block;

    color: rgb(var(--das-color-primary));
  }
}
.room-schedule_container {
  height: calc(100vh - 70px);
  --border: 1px solid var(--das-border-color);
  min-height: 0;
  overflow: clip;
  display: grid;
  grid-template-columns: min-content 1fr;
  &--sidebar {
    grid-template-columns: 1fr;
  }
}
.room-schedule_calendar {
  min-height: 0;
  min-width: 0;
}
.room-schedule_sidebar {
  overflow-y: auto;
  hr {
    margin-top: 16px;
    margin-bottom: 16px;
  }
  width: min-content;
  padding: 16px;
  border-right: var(--border);
  &_buttons {
    margin-top: 16px;
  }
  &_calendar {
    display: grid;
    gap: 16px;
  }
}

.container {
  height: 100%;
  width: 100%;
  background-color: green;
  display: grid;
  grid-template-columns: 240px 1fr;
  grid-template-rows: auto 1fr;
}
.datagrid-header {
  overflow-x: scroll;
  background-color: aqua;
}
.sidebar-data {
  overflow-x: scroll;
  background-color: orchid;
}
.sidebar-header {
  overflow-x: scroll;
  width: 100%;
  height: 80px;
  background-color: blue;
}
.datagrid-data {
  overflow: scroll;
  min-width: 0;
}
.datagrid {
  background-color: yellow;
  position: relative;
  border: 5px solid grey;
}

.item {
  height: 20px;
  width: 20px;
  background-color: black;
}

.type-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
}
.type-color {
  border-radius: 4px;
  height: 14px;
  width: 14px;
}
.type-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;
  line-height: 20px;
  font-size: 14px;
}
.vc-day-content {
  background-color: rgb(var(--das-color-primary)) !important;
}
.fc-selected-rooms {
  font-size: 14px;
  font-variant-numeric: tabular-nums;
}
</style>
